import { render } from "./MyPermision.vue?vue&type=template&id=6fdcd24c&scoped=true"
import script from "./MyPermision.vue?vue&type=script&lang=js"
export * from "./MyPermision.vue?vue&type=script&lang=js"

import "./MyPermision.vue?vue&type=style&index=0&id=6fdcd24c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdcd24c"]])

export default __exports__